import {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {SunIcon, MinimalIcon, MoonIcon, GitHubIcon} from './icons';

const THEME_LABELS = {dark: 'Dark', light: 'Light', minimal: 'Minimal', github: 'GitHub'};

export default function AccountMenu({username, onLogout, onAccountSettings, theme, onToggleTheme}) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const themeIcon = theme === 'dark' ? <SunIcon/> : theme === 'light' ? <MinimalIcon/> : theme === 'minimal' ? <GitHubIcon/> : <MoonIcon/>;
    const nextThemeLabel = theme === 'dark' ? 'Light' : theme === 'light' ? 'Minimal' : theme === 'minimal' ? 'GitHub' : 'Dark';

    useEffect(() => {
        if (!open) return;
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [open]);

    return (
        <div className="account-menu" ref={ref}>
            <button
                className="account-menu-trigger"
                onClick={() => setOpen(o => !o)}
                aria-haspopup="true"
                aria-expanded={open}
            >
                <span className="account-menu-username">{username}</span>
                <svg className="account-menu-chevron" width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path d="M2.5 3.5L5 6.5L7.5 3.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </button>
            {open && (
                <div className="account-menu-dropdown">
                    <button
                        className="account-menu-item"
                        onClick={() => { setOpen(false); onAccountSettings(); }}
                    >
                        Account settings
                    </button>
                    <button
                        className="account-menu-item account-menu-item--theme"
                        onClick={onToggleTheme}
                    >
                        <span className="account-menu-theme-icon">{themeIcon}</span>
                        <span>{THEME_LABELS[theme]}</span>
                        <span className="account-menu-theme-next">→ {nextThemeLabel}</span>
                    </button>
                    <div className="account-menu-divider"/>
                    <button
                        className="account-menu-item account-menu-item--danger"
                        onClick={() => { setOpen(false); onLogout(); }}
                    >
                        Sign out
                    </button>
                </div>
            )}
        </div>
    );
}

AccountMenu.propTypes = {
    username: PropTypes.string.isRequired,
    onLogout: PropTypes.func.isRequired,
    onAccountSettings: PropTypes.func.isRequired,
    theme: PropTypes.string.isRequired,
    onToggleTheme: PropTypes.func.isRequired,
};
